import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { ENTRY_VALUE_DEMOS } from "@/features/developer/fixtures/uiDemos";
import { EntryValueSwitch } from "@/features/entry-values/components/EntryValueSwitch";
import { useNav } from "@/utils/nav";
import { ui } from "@patient-watch/ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/forms/entry-values")({
    component: EntryValuesDemoPage,
});

function EntryValuesDemoPage() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Forms", route: { to: "/design/forms" } },
        { label: "Entry values", route: { to: "/design/forms/entry-values" } },
    ]);

    return (
        <AdminPageLayout
            title="Entry values"
            description="Read-only display components from EntryValueSwitch, one example per handled input_key."
            maxWidthClassName="max-w-4xl"
        >
            <div className="gap-6 grid grid-cols-1">
                {ENTRY_VALUE_DEMOS.map(({ title, entryValue }) => (
                    <ui.Card key={title}>
                        <ui.CardHeader>
                            <ui.CardTitle className="font-mono text-base">{title}</ui.CardTitle>
                            <ui.CardDescription>{entryValue.input_label}</ui.CardDescription>
                        </ui.CardHeader>
                        <ui.CardContent>
                            <EntryValueSwitch entryValue={entryValue} size="md" />
                        </ui.CardContent>
                    </ui.Card>
                ))}
            </div>
        </AdminPageLayout>
    );
}
